export default "__VITE_ASSET__z7B8thuk__"